import type { Tokens } from "@innoclouds/api";
import { useLocalStorage } from "@vueuse/core";
import type { Ref } from "vue";

export const TOKEN_KEYS = {
	ACCESS: "accessToken",
	REFRESH: "refreshToken",
};

export const SESSION_REPLACED_FLAG = "session_replaced_handled";

const createAuth = () => {
	const accessToken: Ref<string | null> = useLocalStorage<string | null>(TOKEN_KEYS.ACCESS, null);
	const refreshToken: Ref<string | null> = useLocalStorage<string | null>(TOKEN_KEYS.REFRESH, null);

	const setTokens = (tokens?: Tokens | null | false) => {
		if (!tokens) return;
		if (tokens.access) accessToken.value = tokens.access;
		if (tokens.refresh) refreshToken.value = tokens.refresh;
		if (tokens.access) sessionStorage.removeItem(SESSION_REPLACED_FLAG);

		return tokens;
	};

	const clear = () => {
		accessToken.value = null;
		refreshToken.value = null;
		localStorage.removeItem(TOKEN_KEYS.ACCESS);
		localStorage.removeItem(TOKEN_KEYS.REFRESH);
		sessionStorage.removeItem(`_${TOKEN_KEYS.ACCESS}`);
		sessionStorage.removeItem(`_${TOKEN_KEYS.REFRESH}`);
	};

	return {
		setTokens,
		clear,
		accessToken,
		refreshToken,
	};
};

type Auth = ReturnType<typeof createAuth>;

let auth: Auth | undefined;

/** Shared singleton — every call must use the same useLocalStorage refs */
export const useAuth = (): Auth => {
	if (!auth) auth = createAuth();
	return auth;
};
